
import Vue from 'vue';
import { Component, Provide, Prop, Emit, Watch } from 'vue-property-decorator';
import mapboxgl from 'mapbox-gl';

export type WithMapFn = (found: (map: mapboxgl.Map) => void) => void;

@Component({
  name: 'MapboxWrapper',
})
export default class MapboxWrapper extends Vue {
  @Prop({ required: true })
  readonly mapId!: string;
  @Prop({ default: 'mapbox://styles/mapbox/streets-v11' })
  readonly mapStyle!: string;
  @Prop({ required: true })
  readonly accessToken!: string;
  @Prop({ default: null })
  readonly mapOptions!: mapboxgl.MapboxOptions;

  @Provide('withMap')
  readonly withMap = this.withMapFn.bind(this);

  initial: boolean = true;
  initialized: boolean = false;
  private map?: mapboxgl.Map = undefined;

  mounted() {
    mapboxgl.accessToken = this.accessToken;
    let map = new mapboxgl.Map({
      ...this.mapOptions,
      container: this.mapId || this.$refs.container,
      style: this.mapStyle,
      center: [12.2247866, 47.6928624],
      zoom: 6.5,
    } as mapboxgl.MapboxOptions);
    map.on('load', () => {
      this.map = map;
      this.initial = false;
      this.initialized = true;
      this.mapLoaded();
      // this.addMarker();
    });
  }

  //#region Map Properties and manipulation

  @Emit('load')
  public mapLoaded() {
    return {
      map: this.map,
      component: this,
    };
  }

  @Watch('mapStyle')
  private onMapStyleChanged(nextStyle: string, prev: string) {
    if (nextStyle != prev) {
      (this.map as mapboxgl.Map).setStyle(nextStyle);
    }
  }

  public withMapFn(found: (map: mapboxgl.Map) => void): void {
    if (this.map) {
      found(this.map);
    } else {
      // waiting for map load
      setTimeout(() => this.withMapFn(found), 50);
    }
  }

  //public addMarker() {
  //    let marker = new mapboxgl.Marker({
  //        draggable: true
  //    })
  //        .setLngLat(this.mapOptions.center as mapboxgl.LngLatLike)
  //        .addTo(<mapboxgl.Map>this.map);
  //}
  //#endregion

}
